import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function CustomOrderPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", furniture_type: "", wood_type: "", dimensions: "", budget: "", description: "" });
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/custom-orders", form);
      setSent(true);
      toast.success("Request submitted — we'll be in touch soon");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to submit");
    } finally { setSubmitting(false); }
  };

  return (
    <div>
      <section className="relative h-[50vh] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1497219055242-93359eeed651" alt="" className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/70 to-transparent"/>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 h-full flex items-end pb-12 text-white">
          <div>
            <p className="eyebrow text-[#E7D3B3]">Bespoke Craft</p>
            <h1 className="font-serif text-5xl md:text-7xl mt-2 tracking-tight">Commission Your Piece</h1>
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        {sent ? (
          <div className="text-center py-16">
            <p className="eyebrow">Received.</p>
            <h2 data-testid="custom-order-thanks" className="font-serif text-4xl mt-3">Thank you for the trust.</h2>
            <p className="mt-4 text-stone-600 max-w-lg mx-auto">One of our master craftsmen will contact you within 48 hours to sketch, quote, and plan your piece.</p>
          </div>
        ) : (
          <>
            <p className="text-stone-600 leading-relaxed max-w-2xl mb-10">Tell us what you dream of — a dining table for eight, a study you'll write your novel on, a wardrobe with a secret drawer. We build one-of-one.</p>
            <form onSubmit={submit} className="grid md:grid-cols-2 gap-5">
              <input data-testid="co-name" required placeholder="Your Name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} />
              <input data-testid="co-email" required type="email" placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} />
              <input data-testid="co-phone" required placeholder="Phone (WhatsApp preferred)" value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} />
              <input data-testid="co-type" required placeholder="Furniture type (e.g. Dining Table)" value={form.furniture_type} onChange={(e)=>setForm({...form,furniture_type:e.target.value})} />
              <input data-testid="co-wood" placeholder="Preferred wood (Sheesham / Teak / …)" value={form.wood_type} onChange={(e)=>setForm({...form,wood_type:e.target.value})} />
              <input data-testid="co-dimensions" placeholder="Approx. dimensions" value={form.dimensions} onChange={(e)=>setForm({...form,dimensions:e.target.value})} />
              <input data-testid="co-budget" placeholder="Budget range (₹)" value={form.budget} onChange={(e)=>setForm({...form,budget:e.target.value})} />
              <div className="md:col-span-2">
                <textarea data-testid="co-description" required placeholder="Describe your idea in detail — inspiration, materials, purpose…" rows={6} value={form.description} onChange={(e)=>setForm({...form,description:e.target.value})} />
              </div>
              <div className="md:col-span-2">
                <button data-testid="co-submit" disabled={submitting} className="btn-primary disabled:opacity-60">{submitting ? "Sending…" : "Send Request"}</button>
              </div>
            </form>
          </>
        )}
      </section>
    </div>
  );
}
